import { useQuery } from '@tanstack/react-query';
import { Navigate } from '@tanstack/react-router';

import { workspaceQuery } from '@/shared/api/queries/workspace';
import { AppShell } from '@/shared/layout/app-shell';
import { Alert } from '@/shared/ui/alert';
import { Button } from '@/shared/ui/button';
import { PageSkeleton } from '@/shared/ui/skeleton';

/**
 * Resolve the current activity in a mounted query, where cancellation can be retried. Studio
 * and the Overview read the same cache for their resume card, so the redirect waits for a
 * fresh answer instead of trusting whichever selection they last saw.
 */
export function WorkshopEntryPage() {
  const current = useQuery({ ...workspaceQuery, refetchOnMount: 'always', refetchInterval: false });
  const resolved = current.data && !current.isFetching && !current.error ? current.data : null;
  if (resolved) {
    return resolved.activity?.accessible ? (
      <Navigate to="/workshop/$activityId" params={{ activityId: resolved.activity.id }} replace />
    ) : (
      <Navigate to="/studio" replace />
    );
  }

  return (
    <AppShell title="Workshop">
      {current.isFetching && !current.error ? (
        <PageSkeleton label="Loading your workshop…" />
      ) : null}
      {current.error ? (
        <div className="space-y-4">
          <Alert>Could not load your Workshop. Check your connection and try again.</Alert>
          <Button
            loading={current.isFetching}
            loadingLabel="Loading workshop…"
            onClick={() => void current.refetch()}
          >
            Retry
          </Button>
        </div>
      ) : null}
    </AppShell>
  );
}
